import React from 'react'
import Highlighter from 'react-highlight-words';

function SMCHighlighter({
    highlight,
    text,
    highlightClassName,
    style,
    className,
    children
}) {
    return (
        <Highlighter
            searchWords={[highlight]}
            textToHighlight={text}
            highlightClassName={highlightClassName}
            className={className}
            style={style}
            autoEscape
        >
            {children}
        </Highlighter>
    );
}

export default SMCHighlighter;